/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 *  When the cart is updated by adjusting the quantity or removing a product, it triggers
 * "cart:update" which can be used to check the cart after updates
 *
 */


document.addEventListener('cart:update', function(){
    updateCartAttributeTrigger();
});

document.addEventListener('product:added', function(){
    updateCartAttributeTrigger();
});

document.addEventListener('cart:rerendered', function(){
    console.log('upsells');
    renderUpsells();
});


function updateCartAttributeTrigger() {
    // Get current cart data
    fetch(window.routes.cartUrl + '.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (cart) {
        cart.json().then(function (content) {
            const items = content.items;
            let totalBoxesInCart = 0;

            // Get total boxes per line item
            let result = Promise.all(items.map(getLineItemBoxes)).then(data => {
                for (let index = 0; index < data.length; index++) {
                    totalBoxesInCart += data[index];
                }
                updateCartAttribute(totalBoxesInCart);
            });

        })

    })
}
// Get total number of boxes for a line item.
// Get the tag with the boxes: prefix and get the following number and multiply by quantity
function getLineItemBoxes(lineItem) {
    const url = '/products/' + lineItem.handle + '.js';
    return fetch(url)
        .then(data => {
            if (data.status === 200) {
                return data;
            }
        })
        .then(data => data.json())
        .then(data => {
            const boxesTag = data.tags.find(getBoxes);
            if (boxesTag != undefined) {
                const boxes = boxesTag.replace('boxes:','');
                const totalBoxes = boxes * lineItem.quantity;
                return totalBoxes;
            }
        })
}

// Get tag with boxes: prefix
function getBoxes(tag) {
    return tag.includes('boxes:');
}

// Update the cart value
function updateCartAttribute(boxes) {
    fetch('/cart/update' + '.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body:
            JSON.stringify(
                {attributes: {
                        'Total Boxes': boxes
                    }
                })
    }).then(function(response) {

    })
}



let warrartyJSONselect = document.querySelector('[data-warranty-product-json]');
let warrartyJSON = [];

if (warrartyJSONselect) {
    try {
        warrartyJSON = JSON.parse(warrartyJSONselect.innerHTML);
        // Remove warranty items to not promote
        warrartyJSON = warrartyJSON.filter(product => !([8040085356798,8026458358014,8026458849534,8044204785918,8026458259710,8026458620158,8026454655230].includes(product.id)) )
    } catch (error) {
        warrartyJSON = [];
        console.error('Unable to load warranty products.', error);
    }
}

function getIndexOfRange(number) {
    if (number == 1) {
        return 0
    } else if (number >=2 && number <=4) {
        return 1
    } else {
        return 2
    }
}

function injectGuardsmanUpsellStyles() {
    if (document.getElementById('guardsman-upsell-styles')) return;

    const style = document.createElement('style');
    style.id = 'guardsman-upsell-styles';
    style.textContent = `
        .guardsman-upsell{display:grid;gap:12px}
        .guardsman-upsell-item{width:100%;padding:14px;border:1px solid #dbdde4;border-radius:8px;background:#fff}
        .guardsman-upsell-product-row{display:flex;align-items:center;gap:14px;min-width:0}
        .guardsman-upsell-image-link{flex:0 0 80px;width:80px;height:80px;border-radius:6px;overflow:hidden;background:#f5f5f5}
        .guardsman-upsell-image{display:block;width:80px;height:80px;object-fit:contain}
        .guardsman-upsell .warranty-detail{display:flex;flex:1 1 auto;align-items:center;justify-content:space-between;gap:16px;min-width:0}
        .guardsman-upsell-title{color:inherit;font-weight:600;line-height:1.35;text-decoration:none}
        .guardsman-upsell-title:hover,.guardsman-upsell-title:focus{text-decoration:underline}
        .guardsman-upsell-price{flex:0 0 auto;font-weight:700;white-space:nowrap}
        .guardsman-upsell-button{display:flex;width:100%;min-height:44px;margin-top:12px;justify-content:center;align-items:center;text-align:center}
        @media screen and (max-width:640px){
            .guardsman-upsell-container{padding-bottom:20px!important}
            .guardsman-upsell-item{padding:12px}
            .guardsman-upsell-product-row{gap:10px}
            .guardsman-upsell-image-link,.guardsman-upsell-image{flex-basis:64px;width:64px;height:64px}
            .guardsman-upsell .warranty-detail{gap:8px}
            .guardsman-upsell-title{font-size:13px}
            .guardsman-upsell-price{font-size:14px}
            .guardsman-upsell-button{margin-top:10px}
        }
    `;
    document.head.appendChild(style);
}

function renderUpsells(){
    const upsellContainer = document.querySelector('.guardsman-upsell');

    if (!upsellContainer || warrartyJSON.length === 0) {
        return;
    }

    injectGuardsmanUpsellStyles();

    fetch(window.routes.cartUrl + '.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (cart) {
        cart.json().then(function (content) {
            const items = content.items;

            console.log('~~~~');
            console.log('getWarrantyTags');

            // items == cart items
            // Running getWarrantyTags for each cart item



            let totalFabricSeats = 0;
            let totalLeatherSeats = 0;

            let alltags = Promise.all(items.map(getProductTags)).then(data => {


                let fabricLounges = data.filter((item) => {
                    return (item.tags.includes("Material:Fabric") || item.tags.includes("Material:Suede") || item.tags.includes("Material:Velvet")) && item.tags.includes("Category:Lounge");
                });

                let leatherLounges = data.filter((item) => {
                    return item.tags.includes("Material:Leather") && item.tags.includes("Category:Lounge");
                });

                fabricLounges.forEach(item => {
                    let seatTag = item.tags.find(tag => tag.startsWith('Seating Capacity:'));
                    let capacity = parseInt(seatTag.replace('Seating Capacity:','').replace(' seater',''));
                    totalFabricSeats += (capacity * parseInt(item.qty));
                });

                leatherLounges.forEach(item => {
                    let seatTag = item.tags.find(tag => tag.startsWith('Seating Capacity:'));
                    let capacity = parseInt(seatTag.replace('Seating Capacity:','').replace(' seater',''));
                    totalLeatherSeats += (capacity * parseInt(item.qty));
                });


                const fabricLoungeMap = [
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Fabric') && prod.tags.includes('Seating Capacity:1 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Fabric') && prod.tags.includes('Seating Capacity:4 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Fabric') && prod.tags.includes('Seating capacity:8 seater')})
                ];
                const leatherLoungeMap = [
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Leather') && prod.tags.includes('Seating Capacity:1 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Leather') && prod.tags.includes('Seating Capacity:4 seater')}),
                    warrartyJSON.find(prod => {return prod.tags.includes('Product Category:Lounge') && prod.tags.includes('Material:Leather') && prod.tags.includes('Seating capacity:8 seater')})
                ];

                let fabricLoungeWarranty = [];
                let leatherLoungeWarranty = [];

                const cart_ids = items.map(i => i['id']);

                if (totalFabricSeats > 0) {
                    if (totalFabricSeats <= 8) {
                        let index = getIndexOfRange(totalFabricSeats);
                        fabricLoungeWarranty.push(fabricLoungeMap[index])
                    } else {
                        let seats = Math.floor(totalFabricSeats / 8);
                        let remainder = totalFabricSeats % 8;
                        let i = 0;
                        while (i < seats) {
                            fabricLoungeWarranty.push(fabricLoungeMap[2])
                            i++;
                        }
                        let index = getIndexOfRange(remainder);
                        fabricLoungeWarranty.push(fabricLoungeMap[index])
                    }

                    fabricLoungeWarranty = fabricLoungeWarranty.filter(Boolean).filter((prod) => {
                        return !(cart_ids.includes(prod.variants[0].id));
                    });
                    fabricLoungeWarranty.forEach(item => {
                        upsellContainer.innerHTML += buildUpsellProduct(item);
                    });
                }

                if (totalLeatherSeats > 0) {
                    if (totalLeatherSeats <= 8) {
                        let index = getIndexOfRange(totalLeatherSeats);
                        leatherLoungeWarranty.push(leatherLoungeMap[index])
                    } else {
                        let seats = Math.floor(totalLeatherSeats / 8);
                        let remainder = totalLeatherSeats % 8;
                        let i = 0;
                        while (i < seats) {
                            leatherLoungeWarranty.push(leatherLoungeMap[2])
                            i++;
                        }
                        let index = getIndexOfRange(remainder);
                        leatherLoungeWarranty.push(leatherLoungeMap[index])
                    }
                    //console.log(leatherLoungeWarranty, 'leatherLoungeWarranty');
                    leatherLoungeWarranty = leatherLoungeWarranty.filter(Boolean).filter((prod) => {
                        return !(cart_ids.includes(prod.variants[0].id));
                    });
                    //console.log(leatherLoungeWarranty, 'leatherLoungeWarranty 2');
                    leatherLoungeWarranty.forEach(item => {
                        upsellContainer.innerHTML += buildUpsellProduct(item);
                    })
                }



            });


            // Logic for warranty suggestions per line item (no couches)
            let result = Promise.all(items.map(getWarrantyTags)).then(data => {

                let flat_data = data.flat();

                //flat_data = flat_data.filter(prod => {return !(prod.title.startsWith('Guardsman ComfortMark II'))});

                const cart_ids = items.map(i => i['id']);
                flat_data = flat_data.filter(Boolean).filter((prod) => {
                    return !(cart_ids.includes(prod.variants[0].id));
                });

                if(flat_data.length > 0) {
                    document.querySelector('.guardsman-upsell-description').classList.remove('hidden');
                }

                flat_data.forEach(item => {
                    upsellContainer.innerHTML += buildUpsellProduct(item);
                });
            });

        })

    });
}

function buildUpsellProduct(product){

    // Keep the warranty matching logic above unchanged; this only controls presentation.
    const escapedTitle = String(product.title).replace(/[&<>"']/g, character => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    })[character]);
    let htmlString = `<article class="guardsman-upsell-item">
        <div class="guardsman-upsell-product-row">
            <a class="guardsman-upsell-image-link" href="/products/${product.handle}" aria-label="View ${escapedTitle}">
                <img class="guardsman-upsell-image" src="${window.getSizedImageUrl(product.featured_image, '160x')}" alt="${escapedTitle}" width="80" height="80" loading="lazy"/>
            </a>
            <div class="warranty-detail">
                <a class="guardsman-upsell-title" href="/products/${product.handle}">${escapedTitle}</a>
                <div class="guardsman-upsell-price">${window.formatMoney(product.price, window.theme.moneyFormat)}</div>
            </div>
        </div>
        <a class="guardsman-upsell-button button button--primary button--small" href="${window.routes.cartAddUrl}?id=${product.variants[0].id}&quantity=1" aria-label="Add ${escapedTitle} to cart">Add to cart</a>
    </article>`;

    return htmlString;

}

function getProductTags(lineItem) {
    const url = '/products/' + lineItem.handle + '.js';
    return fetch(url)
        .then(data => {
            if (data.status === 200) {
                return data;
            }
        })
        .then(data => data.json())
        .then(data => {
            return {tags: data.tags, id: lineItem.id, qty: lineItem.quantity}
        })
}

function getWarrantyTags(lineItem) {

    const url = '/products/' + lineItem.handle + '.js';
    return fetch(url)
        .then(data => {
            if (data.status === 200) {
                return data;
            }
        })
        .then(data => data.json())
        .then(data => {

            //console.log('---------- START ----------');
            return warrartyJSON.filter(warrantyProduct => {


                let warrantyCategoryTag = warrantyProduct.tags.find(tag => {
                    return tag.startsWith('Product Category:')
                });
                let productCategoryTag = data.tags.find(tag => {
                    return tag.startsWith('Category:')
                });

                if (productCategoryTag == 'Category:Lounge') return;  // For now ignore lounge products


                // Always return Timber products if warranty is Timber
                if (data.tags.includes('Material:Timber') && warrantyProduct.title.includes('Timber')) {
                    return true;
                }

                if (warrantyCategoryTag == undefined ||  productCategoryTag == undefined) return false;

                if (warrantyCategoryTag.split('Product Category:').pop()!== productCategoryTag.split('Category:').pop()) return false;

                // If Product is Outdoor and Warranty is Outdoor, always return
                if (productCategoryTag.split('Category:').pop() == 'Outdoor') {
                    return true;
                }

                let filteredTags = data.tags.filter(tag => {
                    return tag.startsWith('Material:') || tag.startsWith('Size:') || tag.startsWith('Seating Capacity:')
                });
                let filteredWarrantyTags = warrantyProduct.tags.filter(tag => {
                    return tag.startsWith('Material:') || tag.startsWith('Size:') || tag.startsWith('Seating Capacity:')
                });

                filteredTags = filteredTags.map(function(item) { return item == 'Material:Suede' || item == 'Material:Velvet' ? 'Material:Fabric' : item; });

                return filteredTags.every(value => filteredWarrantyTags.includes(value));


            });
        })
}
